import React, { useRef } from 'react';
import { useReactToPrint } from 'react-to-print';

import { ComponentToPrint } from './ComponentToPrint';

const PrintPage = () => {
  const componentRef = useRef();
  
  const handlePrint = useReactToPrint({
    content: () => componentRef.current,
  });

  return (
    <div>ewgwegwge
      wergewrg
      ergerg
      <div style={{ display: "none" }}><ComponentToPrint ref={componentRef} /></div>
      <button onClick={handlePrint}>Print this out!</button>
    </div>
  );
};
export default PrintPage